// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-profile-user .wm-profile-user-container {
  --user-container-padding: 15px;
  --user-container-content-height: 64px;
  cursor: pointer;
  padding: var(--user-container-padding);
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}
wm-profile-user .wm-profile-user-container .wm-profile-user-avatar {
  display: block;
  flex-shrink: 0;
  width: var(--user-container-content-height);
  height: var(--user-container-content-height);
}
wm-profile-user .wm-profile-user-container .wm-profile-user-avatar-initials {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--wm-color-primary, #4285f4);
  color: #fff;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 50%;
}
wm-profile-user .wm-profile-user-container .wm-profile-user-header-container {
  display: flex;
  margin-left: 20px;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  min-width: 0;
}
wm-profile-user .wm-profile-user-container .wm-profile-user-header-container .wm-profile-user-name {
  margin: 0 0 3px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
wm-profile-user .wm-profile-user-container .wm-profile-user-header-container .wm-profile-user-email {
  font-size: var(--wm-font-sm);
  color: var(--wm-color-darkgrey);
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/profile/profile-user/profile-user.component.scss"],"names":[],"mappings":"AACE;EACE,8BAAA;EACA,qCAAA;EAEA,eAAA;EACA,sCAAA;EACA,aAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;AADJ;AAEI;EACE,cAAA;EACA,cAAA;EACA,2CAAA;EACA,4CAAA;AAAN;AAEI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAN;AAEI;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;AAAN;AACM;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACR;AACM;EACE,4BAAA;EACA,+BAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACR","sourcesContent":["wm-profile-user{\n  .wm-profile-user-container {\n    --user-container-padding: 15px;\n    --user-container-content-height: 64px;\n\n    cursor: pointer;\n    padding: var(--user-container-padding);\n    display: flex;\n    width: 100%;\n    justify-content: flex-start;\n    align-items: center;\n    .wm-profile-user-avatar {\n      display: block;\n      flex-shrink: 0;\n      width: var(--user-container-content-height);\n      height: var(--user-container-content-height);\n    }\n    .wm-profile-user-avatar-initials {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: var(--wm-color-primary, #4285f4);\n      color: #fff;\n      font-size: 1.2rem;\n      font-weight: 600;\n      border-radius: 50%;\n    }\n    .wm-profile-user-header-container {\n      display: flex;\n      margin-left: 20px;\n      align-items: flex-start;\n      justify-content: center;\n      flex-direction: column;\n      min-width: 0;\n      .wm-profile-user-name {\n        margin: 0 0 3px;\n        width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      .wm-profile-user-email {\n        font-size: var(--wm-font-sm);\n        color: var(--wm-color-darkgrey);\n        width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
